export const reportError = (message: string, error?: unknown) => {
  const isDev =
    typeof process !== 'undefined'
      ? process.env.NODE_ENV !== 'production'
      : false;

  if (!isDev) return;

  // Keep noise out of production while preserving signal in dev.
  console.error(message, error);
};
